module.exports = __webpack_public_path__ + "6c4a0dbc/img/boston-lights.a623432f.png";